module.exports = __webpack_public_path__ + "img/Linkedin.3ca63a37.svg";